import React from 'react'
import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { ComponentProps, createBackendTransformer, createDisplayTransformer } from '../../../types/filters'
import { CourierAutoCompleter } from '../../Courier/config/filters/CourierAutoCompleter'
import { CourierServiceAutoCompleter } from '../../Courier/config/filters/CourierServiceAutoCompleter'
import { WeekDayFilter } from './filters/WeekDayFilter'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'courierName',
    label: 'Courier',
    type: 'custom',
    // incluye couriers inactivos: en este mantenedor se necesita poder filtrar por ellos
    Component: (props: ComponentProps) => (
      <CourierAutoCompleter {...props} includeInactive />
    )
  },
  {
    order: 2,
    key: 'courierServiceName',
    label: 'Servicio de Courier',
    type: 'custom',
    // incluye servicios de couriers inactivos: en este mantenedor se necesita poder filtrar por ellos
    Component: (props: ComponentProps) => (
      <CourierServiceAutoCompleter {...props} includeInactive />
    )
  },
  {
    order: 3,
    key: 'dayId',
    label: 'Día de la Semana',
    type: 'custom',
    Component: WeekDayFilter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  }
]